import React from "react";

// Vive a lo Grande — Americas globe with flag brushstrokes
export const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_vive-wealth/artifacts/9596imqb_500500viviealogrande.com%20%28GHL%20Logo%29%20%28Logo%29%20%281%29.png";

export const BrandLogo = ({ size = 28, className = "" }) => (
    <img
        src={LOGO_URL}
        alt="Vive a lo Grande"
        width={size}
        height={size}
        className={`rounded-full ${className}`}
        style={{ objectFit: "cover" }}
        loading="eager"
    />
);

export default BrandLogo;
